// extracted by mini-css-extract-plugin
export var cardIcon = "_4b-4";
export var checkboxCard = "_4b-0";
export var checkboxCardSelected = "_4b-1";
export var disabled = "_4b-2";
export var outerBorder = "_4b-3";
export var spacerMedium = "_4b-7";
export var spacerSmall = "_4b-6";
export var spacerXsmall = "_4b-5";